// extracted by mini-css-extract-plugin
module.exports = {"freebieWrapper":"LAFahrplanSelbstliebe_freebieWrapper__SkTvR","freebieImageWrapper":"LAFahrplanSelbstliebe_freebieImageWrapper__iGivU","badge":"LAFahrplanSelbstliebe_badge__JJ5aH"};